import React from 'react';
import { PayPalButtons } from '@paypal/react-paypal-js';
import { PayPalService, DonationAnalytics } from '../services/donationService';

const PayPalButton = ({ 
  amount, 
  currency = 'USD', 
  onSuccess, 
  onError, 
  onCancel,
  disabled = false 
}) => {
  console.log('🔧 PayPal Button Props:', { amount, currency, disabled });
  console.log('🔧 PayPal Client ID:', process.env.REACT_APP_PAYPAL_CLIENT_ID);

  const handleCreateOrder = (data, actions) => {
    console.log('🚀 PayPal createOrder called:', { data, amount, currency });
    DonationAnalytics.trackDonationAttempt('paypal', amount, currency);
    
    const orderData = PayPalService.createOrder(amount, currency);
    console.log('📦 Order data:', orderData);
    
    return actions.order.create(orderData);
  };

  const handleApprove = async (data, actions) => {
    console.log('✅ PayPal onApprove called:', data);
    try {
      const order = await PayPalService.onApprove(data, actions);
      console.log('💰 Payment successful:', order);
      
      DonationAnalytics.trackDonationSuccess('paypal', amount, currency, order.id);
      
      if (onSuccess) {
        onSuccess(order);
      }
      
      return order;
    } catch (error) {
      console.error('❌ PayPal approve error:', error);
      DonationAnalytics.trackDonationError('paypal', error.message);
      
      // Show user-friendly error message
      alert(`Payment processing failed: ${error.message}. Please try again or contact support.`);
      
      if (onError) {
        onError(error);
      }
      throw error;
    }
  };

  const handleError = (error) => {
    console.error('❌ PayPal error:', error);
    console.error('❌ Error details:', JSON.stringify(error, null, 2));
    DonationAnalytics.trackDonationError('paypal', error.message);
    
    // Show detailed error information
    let errorMessage = 'PayPal payment failed. ';
    if (error.message) {
      errorMessage += error.message;
    } else if (error.err) {
      errorMessage += error.err;
    } else {
      errorMessage += 'Please try again or contact support.';
    }
    
    alert(errorMessage);
    
    if (onError) {
      onError(error);
    }
  };

  const handleCancel = (data) => {
    console.log('❌ PayPal cancelled:', data);
    alert('Payment was cancelled. You can try again anytime.');
    if (onCancel) {
      onCancel(data);
    }
  };

  if (disabled) {
    return (
      <div className="paypal-button-disabled">
        <div className="btn btn-secondary w-100 d-flex align-items-center justify-content-center" style={{height: '55px'}}>
          <i className="bi bi-paypal me-2"></i>
          PayPal (Select amount first)
        </div>
      </div>
    );
  }

  // Debug: Check if we have required props
  if (!amount || amount <= 0) {
    console.error('❌ PayPal Button: Invalid amount:', amount);
    return (
      <div className="alert alert-danger">
        <i className="bi bi-exclamation-triangle me-2"></i>
        Invalid amount for PayPal payment
      </div>
    );
  }

  return (
    <div className="paypal-button-container">
      <div className="mb-2">
        <small className="text-muted">
          Debug: Amount = {amount}, Currency = {currency}
        </small>
      </div>
      <PayPalButtons
        style={{
          layout: 'vertical',
          color: 'blue',
          shape: 'rect',
          label: 'donate',
          height: 55
        }}
        createOrder={handleCreateOrder}
        onApprove={handleApprove}
        onError={handleError}
        onCancel={handleCancel}
        disabled={disabled}
        forceReRender={[amount, currency]} // Force re-render when amount/currency changes
      />
    </div>
  );
};

export default PayPalButton;